import React from 'react';
import { RCButton, RCFlex } from '@reverbdotcom/cadence/components';
import I18n from 'i18n-js';
import { ButtonVariant, DEFAULT_VARIANT } from '@reverbdotcom/cadence/components/RCButton/styling';

interface IProps {
  limit: number;
  offset: number;
  total: number;
  loadMoreHandler: () => void;
  title?: string;
  variant?: ButtonVariant;
  justify?: 'start' | 'center' | 'end' | 'space-between' | 'space-around' | 'space-evenly';
  align?: 'stretch' | 'start' | 'center' | 'end';
  disabled?: boolean;
}

export default function RQLLoadMoreButton({
  limit,
  offset,
  total,
  loadMoreHandler,
  variant = DEFAULT_VARIANT,
  title = null,
  justify = 'center',
  align = 'center',
  disabled = false,
}: IProps) {

  const currentPage = Math.max(Math.ceil(offset / limit) + 1, 1);
  const totalPages = Math.ceil(total / limit);
  if (currentPage === totalPages) return null;
  if (total <= 0) return null;

  return (
    <RCFlex justify={justify} align={align}>
      <RCButton
        variant={variant}
        onClick={loadMoreHandler}
        disabled={disabled}
      >
        {title || I18n.t('discovery.sellFlow.search.loadMore')}
      </RCButton>
    </RCFlex>
  );
}
